import i18n from '@/i18n';
export var RolesEnum;
(function (RolesEnum) {
    RolesEnum["ROOT"] = "root";
    RolesEnum["ADMIN"] = "administrator";
    RolesEnum["MANAGER"] = "manager";
    RolesEnum["TRAINER"] = "trainer";
    RolesEnum["SUPERVISOR"] = "internal-supervisor";
    RolesEnum["BOARD"] = "board-member";
    RolesEnum["TEACHER"] = "teacher";
    RolesEnum["EXPERT_TEACHER"] = "expert-teacher";
    RolesEnum["GUARDIAN"] = "guardian";
    RolesEnum["STUDENT"] = "student";
})(RolesEnum || (RolesEnum = {}));
export default class Roles {
    static get items() {
        return Object.keys(Roles.texts).map((value) => ({
            id: Roles.values[value],
            name: Roles.texts[value],
        }));
    }
    static get values() {
        return {
            [RolesEnum.ROOT]: 'root',
            [RolesEnum.ADMIN]: 'administrator',
            [RolesEnum.MANAGER]: 'manager',
            [RolesEnum.TRAINER]: 'trainer',
            [RolesEnum.SUPERVISOR]: 'internal-supervisor',
            [RolesEnum.BOARD]: 'board-member',
            [RolesEnum.TEACHER]: 'teacher',
            [RolesEnum.EXPERT_TEACHER]: 'expert-teacher',
            [RolesEnum.GUARDIAN]: 'guardian',
            [RolesEnum.STUDENT]: 'student',
        };
    }
    static get texts() {
        return {
            [RolesEnum.ROOT]: i18n.tc('roles.root'),
            [RolesEnum.ADMIN]: i18n.tc('roles.administrator'),
            [RolesEnum.MANAGER]: i18n.tc('roles.specialist'),
            [RolesEnum.TRAINER]: i18n.tc('roles.trainer'),
            [RolesEnum.SUPERVISOR]: i18n.tc('roles.supervisor'),
            [RolesEnum.BOARD]: i18n.tc('roles.board-member'),
            [RolesEnum.TEACHER]: i18n.tc('roles.teacher'),
            [RolesEnum.EXPERT_TEACHER]: i18n.tc('roles.expert-teacher'),
            [RolesEnum.GUARDIAN]: i18n.tc('roles.guardian'),
            [RolesEnum.STUDENT]: i18n.tc('roles.student'),
        };
    }
    static get roleWeight() {
        return {
            [RolesEnum.ROOT]: 0,
            [RolesEnum.ADMIN]: 1,
            [RolesEnum.MANAGER]: 4,
            [RolesEnum.TRAINER]: 2,
            [RolesEnum.SUPERVISOR]: 5,
            [RolesEnum.BOARD]: 3,
            [RolesEnum.TEACHER]: 5,
            [RolesEnum.EXPERT_TEACHER]: 5,
            [RolesEnum.GUARDIAN]: 5,
            [RolesEnum.STUDENT]: 6,
        };
    }
    /**
     * @description Get all items that a user can see based on their role. the weight of their role can be changed on roleWeight() based on client preferences
     *
     * @returns RolesItemInterface[]
     * @argument RolesEnum
     *
     */
    static roleBasedVisibleItems(role) {
        return this.items.filter((item) => Roles.roleWeight[item.id] >= Roles.roleWeight[role]);
    }
}
